import { LoadingIcon } from '@assets/icons';
import { Group } from '@components/layout';

export const LoadingPanel = ({ height = '200px' }: { height?: string }) => {
  return (
    <Group alignItems="center" justifyContent="center" height={height}>
      <LoadingIcon size={12} />
    </Group>
  );
};
